import { MainV3ApiBase } from './base';
import { CardSummary, PayjpTokenResponse } from '../../mainv2/types/card';
import { NewCardInfo } from '../types/payment_info';

declare const Payjp: any;

export const UserCardApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/card');
    },
    /**
     * Returns the {@link CardSummary} that the current user uses, or null if she doesn't have any cards.
     */
    getCurrentCard(): Promise<CardSummary> {
        return this.base().get();
    },
    /**
     * Updates the current card of the user
     * @param {string} token : the token provided from Payjp. Use {@link #createToken} for details
     * @returns {Promise<void>}
     */
    updateCard(token: string): Promise<void> {
        return this.base().put({ card_token: token });
    },
    /**
     * Creates the secure card token from the given {@link NewCardInfo}
     * Or throws {@link PayjpError} if the request is invalid.
     * @param {NewCardInfo} card
     * @returns {Promise<string>}
     */
    createToken(card: NewCardInfo): Promise<PayjpTokenResponse> {
        const payload = {
            number: card.number.replace(/-/g, ''),
            cvc: card.cvc,
            exp_month: card.exp_month,
            exp_year: '20' + card.exp_year,
        };
        return new Promise((resolve, reject) => {
            Payjp.createToken(payload, (status: number, response: any) => {
                if (status === 200) {
                    resolve(response);
                } else {
                    reject(response.error);
                }
            });
        });
    },
};
